import React from 'react';
import { useNavigate } from 'react-router-dom';
import novaAvaliacao from '../images/nova-avaliacao-icone.png';
import avaliacoesRealizadas from '../images/avaliacoes-realizadas-icone.png';
import iconeExcluir from '../images/excluir.png';
import altPhoto from '../images/user-standard.png';
import '../css/Bloco_aluno.css';
import '../css/style.css';

function BlocoAluno({ aluno, onAtualizarAlunoClick, onExcluirAlunoClick, onCompararAvaliacoesClick }) {

    const { name, profile, sexo, idade, foto } = aluno;

    const sexoDictionary = {
        masculino: "Masculino",
        feminino: "Feminino"
    };

    const profileDictionary = {
        homensEMulheresAdultos: "Homens e mulheres adultos",
        mulheresQueDesejamEmagrecer: "Mulheres que desejam emagrecer",
        idosos: "Idosos",
        gestantes: "Gestantes",
        posParto: "Pós-parto",
        obesos: "Obesos",
        diabetesMelitus: "Diabetes Melitus",
        hipertensaoArterial: "Hipertensão arterial",
        depressao: "Depressão"
    };

    const navigate = useNavigate();

    return (
        <div className="bloco-aluno-container">
            <div className="bloco-aluno-content">
                <p className="bloco-aluno-title">ÁREA DO ALUNO</p>
                <div className="bloco-aluno-subtitle-container">
                    <div className="bloco-aluno-subtitle-line"></div>
                    <p className="bloco-aluno-subtitle" style={{ width: 150 }}>DADOS DO ALUNO</p>
                </div>
                <div className="bloco-aluno-dados">
                    <div className="bloco-aluno-dados-left">
                        <img className="bloco-aluno-img" src={foto || altPhoto} alt="Foto do aluno" />
                    </div>
                    <div className="bloco-aluno-dados-right">
                        <p className="bloco-aluno-title bloco-aluno-name">{name || "-"}</p>
                        <div className="bloco-aluno-dados-subitem-container">
                            <div className="bloco-aluno-dados-subitem">
                                <p className="bloco-aluno-dado-title">Idade: </p>
                                <p className="bloco-aluno-dado">{idade || "-"}</p>
                            </div>
                            <div className="bloco-aluno-dados-subitem">
                                <p className="bloco-aluno-dado-title">Sexo: </p>
                                <p className="bloco-aluno-dado">{sexoDictionary[sexo] || "-"}</p>
                            </div>
                        </div>
                        <div className="bloco-aluno-dados-subitem pad-top-10">
                            <p className="bloco-aluno-dado-title">Perfil: </p>
                            <p className="bloco-aluno-dado">{profileDictionary[profile] || "-"}</p>
                        </div>
                    </div>
                </div>
                <div className="bloco-aluno-subtitle-container">
                    <div className="bloco-aluno-subtitle-line"></div>
                    <p className="bloco-aluno-subtitle" style={{ width: 210 }}>AVALIAÇÕES E RELATÓRIOS</p>
                </div>
                <div className="bloco-aluno-bottom">
                    <div>
                        <a className="bloco-aluno-bottom-item bloco-aluno-bottom-item-right" onClick={() => navigate("/avaliacao", { state: { alunoSelecionado: aluno } })}>
                            <img className="bloco-aluno-img-btt" src={novaAvaliacao} alt="Nova Avaliação" />
                            <p className="bloco-aluno-bottom-title">Nova avaliação</p>
                        </a>
                        <a className="bloco-aluno-bottom-item bloco-aluno-bottom-item-right"
                            href="#!"
                            onClick={(e) => {
                                e.preventDefault();
                                onCompararAvaliacoesClick();
                            }}
                            style={{ marginTop: 10 }}
                        >
                            <img className="bloco-aluno-img-btt" src={avaliacoesRealizadas} alt="Atualizar dados do aluno" />
                            <p className="bloco-aluno-bottom-title">Comparar Avaliações</p>
                        </a>
                    </div>
                    <div>
                        <a className="bloco-aluno-bottom-item bloco-aluno-bottom-item-right"
                            href="#!"
                            onClick={(e) => {
                                e.preventDefault();
                                onAtualizarAlunoClick(aluno);
                            }}
                        >
                            <img className="bloco-aluno-img-btt" src={avaliacoesRealizadas} alt="Atualizar dados do aluno" />
                            <p className="bloco-aluno-bottom-title">Atualizar dados</p>
                        </a>
                        <a className="bloco-aluno-bottom-item bloco-aluno-bottom-item-right"
                            href="#!"
                            onClick={(e) => {
                                e.preventDefault();
                                onExcluirAlunoClick();
                            }}
                            style={{ marginTop: 10 }}
                        >
                            <img className="bloco-aluno-img-btt" src={iconeExcluir} alt="Excluir aluno" />
                            <p className="bloco-aluno-bottom-title">Excluir aluno</p>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BlocoAluno;